import React, { useState, useEffect } from "react"
import Button from "../../atoms/button/button"
import "./otp-modal.scss"

const OtpModal = ({
  title = "Necesitamos verificar",
  subtitle = "QUE ERES TÚ",
  description = "Necesitamos verificar que eres tú, te enviaremos un código único para que lo ingreses a continuación.",
  onClickSecondary,
  onSubmit,
  isLoading,
  errorOtp,
  setErrorOtp,
  resendOtp,
  setResendOtp,
  handleResendCode,
  secondaryButtonText = "Eliminar cambio",
}) => {
  const [code, setCode] = useState("")

  return (
    <div className="f-otp-modal">
      <h3 className="f-title-modal">{title}</h3>
      <h4 className="f-subtitle-modal">{subtitle}</h4>
      <p className="f-description-modal">{description}</p>

      <div className="f-input-container">
        <div className="f-input-validation-container">
          <input
            name="f-verification-code-input"
            placeholder="Ingresa el código"
            className={"f-verification-code-input "}
            type="text"
            maxLength="6"
            autoComplete="off"
            onChange={e => {
              setErrorOtp(null)
              setResendOtp(false)
              if (e.target.value.length === 6) {
                onSubmit(e.target.value)
              } else {
                setCode(e.target.value)
              }
            }}
          />
          {errorOtp && (
            <span
              className="icon2-close f-icon f-error-code"
              onClick={() => {
                setCode("")
              }}
            ></span>
          )}
        </div>

        {errorOtp && <label className="f-code-error">{errorOtp}</label>}

        <label className="f-send-code">
          ¿No recibiste un código?{" "}
          <button className={"f-link-send-code"} onClick={handleResendCode}>
            Reenviar código
          </button>
        </label>
        {resendOtp && (
          <p className="f-send-code-re">Tu código ha sido enviado</p>
        )}
        <div className="f-buttons-container">
          <Button
            className={`secondary-pink short ${isLoading ? "disabled" : ""}`}
            title={secondaryButtonText}
            onClick={onClickSecondary}
          />
          <Button
            onClick={() => {
              onSubmit(code)
            }}
            className={`primary-pink short ${isLoading ? "disabled" : ""}`}
            title="Siguiente"
          />
        </div>
      </div>
    </div>
  )
}

export default OtpModal
